import React, { useState, useEffect } from 'react'

import Layout from '../Layout/Layout'
import { url, header } from "../Constent/Constant";

const SocialPolicy = () => {
    const [PolicyData, setPolicyData] = useState('')

    useEffect(() => {
        fetch(`${url}/page/viewpagedata`, {
            method: 'POST',
            body: JSON.stringify({
                name: "Privacy Policy"
            }),
            headers: header
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setPolicyData(data.doc)
            })
    }, [])
    return (
        <Layout>
                {PolicyData && <div className='Policy-container'>
                    <h1 className='Heading'>SOCIAL MEDIA POLICY</h1>
                    <h2>POLICIES AND GUIDELINES IN RELATION TO SOCIAL MEDIA</h2>
                    <p>
                        On The Go Relocation Services encourages and allows the submission of comments via our various social media platforms.
                        <br />
                        <br />
                        On The Go Relocation Services instituted the following comment policy for our social media platforms:
                        <br />
                        <br />
                        We encourage you to share your thoughts on any topic being discussed.  We will review and post comments according to the policy below.  
                        <br />
                        <br />
                        We reserve the right to remove comments that are inconsistent with our policy, at our complete discretion.
                        <br />
                        <br />
                        The views expressed in comments reflect those of the author and do not necessarily reflect the official views of On The Go Relocation Services.
                        <br />
                        <br />
                        Comments that include the following are prohibited and will not be tolerated:
                </p>
                    <li style={{marginTop:'2rem'}}>Vulgar, profane, abusive, or bullying language; personal attacks of any kind; inappropriate religious, sexual, political, or racial references; unsupported accusations.</li>
                    <li>Endorsements of commercial products, services, organizations, or other entities.</li>
                    <li>Endorsements of political parties, candidates, or groups.</li>
                    <li>Content that infringes on copyrights.</li>
                    <li>Solicitation of funds.</li>
                    <li style={{marginBottom:'2rem'}}>Comments on any ongoing investigation of any sort.</li>
                    <p>
                        In posting your comments or other work to websites owned or administered by On The Go Relocation Services, you irrevocably grant On The Go Relocation Services permission to copy, distribute, make derivatives, display or perform your work publicly and free of charge.
                        <br />
                        <br />
                        Please remember that your comments are public. When commenting, please do not include information (e.g., social security number, address) in the text of your comment that personally identifies you in a way you do not intend.
                        <br />
                        <br />
                        We welcome your comments at any time. Reviewing comments will generally occur during regular business hours, Monday through Friday. We will make every effort to deal with comments that are not in line with the stated policy in a timely manner.
                        <br />
                        <br />
                        Records will be kept of all comments that are deleted for the above reason.
                        <br />
                        <br />
                        On The Go Relocation Services reserves the right to block or delete offenders of this policy.
                </p>
                </div>}
            </Layout>
            
    )
}

export default SocialPolicy
